module.exports = "/assets/data/a19b27a1f290f0077d82232e9a42c27f-SE10.data.json";